import type { GetBreadcrumbResponse } from './breadcrumb'

export const getBreadcrumbMock: GetBreadcrumbResponse = [
  {
    title: 'Home',
    link: {
      type: 'internal',
      name: 'home',
      params: {
        locale: 'en-us',
      },
      query: {},
      hash: {},
    },
    slug: '/',
  },
  {
    title: 'Refurbished Phones',
    slug: '/refurbished-smartphones.html',
    link: {
      type: 'internal',
      name: 'landing_page',
      pattern: '/:locale/l/:slugV2/:uuid',
      params: {
        id: '1943',
        slug: 'refurbished-smartphones',
        category: 'refurbished-smartphones.html',
        locale: 'en-us',
        uuid: '0744fd27-8605-465d-8691-3b6dffda5969',
        slugV2: 'smartphones',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.com/en-us/l/smartphones/0744fd27-8605-465d-8691-3b6dffda5969',
    },
  },
  {
    title: 'Apple iPhone',
    slug: '/refurbished-apple-iphones.html',
    link: {
      type: 'internal',
      name: 'landing_page',
      pattern: '/:locale/l/:slugV2/:uuid',
      params: {
        id: '2883',
        slug: 'refurbished-apple-iphones',
        category: 'refurbished-apple-iphones.html',
        locale: 'en-us',
        uuid: '1956d4f7-c95e-4eb2-9f59-004dd6a9919d',
        slugV2: 'apple-iphones',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.com/en-us/l/apple-iphones/1956d4f7-c95e-4eb2-9f59-004dd6a9919d',
    },
  },
  {
    title: 'iPhone 12 Pro',
    slug: '/refurbished-iphone-12-pro.html',
    link: {
      type: 'internal',
      name: 'landing_page',
      pattern: '/:locale/l/:slugV2/:uuid',
      params: {
        id: '3126',
        slug: 'refurbished-iphone-12-pro',
        category: 'refurbished-iphone-12-pro.html',
        locale: 'en-us',
        uuid: '8780caee-a9dd-439b-ba63-29af4b11a29b',
        slugV2: 'iphone-12-pro',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.com/en-us/l/iphone-12-pro/8780caee-a9dd-439b-ba63-29af4b11a29b',
    },
  },
  {
    title: 'iPhone 12 Pro 128GB - Pacific Blue - Unlocked',
    slug: '/tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked/152447.html',
    link: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '152447',
        slug: 'tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked',
        slugV2: 'iphone-12-pro-128-gb-pacific-blue-unlocked',
        uuid: 'a88d8ee0-4955-4565-98bb-f46465253890',
        locale: 'en-us',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-pacific-blue-unlocked/a88d8ee0-4955-4565-98bb-f46465253890',
    },
  },
]
